import { render, staticRenderFns } from "./secondPage.vue?vue&type=template&id=6c6e296d&scoped=true"
import script from "./secondPage.vue?vue&type=script&lang=js"
export * from "./secondPage.vue?vue&type=script&lang=js"
import style0 from "./secondPage.vue?vue&type=style&index=0&id=6c6e296d&prod&scoped=true&lang=css"
import style1 from "./secondPage.vue?vue&type=style&index=1&id=6c6e296d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6e296d",
  null
  
)

export default component.exports